/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderFxLauncherOptions
 */
export interface FxIdApplicationPublicDataBuilderFxLauncherOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderFxLauncherOptions
     */
    AdditionalLauncherArguments?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FxIdApplicationPublicDataBuilderFxLauncherOptions
     */
    GameSearchPaths: Array<string>;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderFxLauncherOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(value: object): value is FxIdApplicationPublicDataBuilderFxLauncherOptions {
    if (!('GameSearchPaths' in value) || value['GameSearchPaths'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderFxLauncherOptions {
    return FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderFxLauncherOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AdditionalLauncherArguments': json['AdditionalLauncherArguments'] == null ? undefined : json['AdditionalLauncherArguments'],
        'GameSearchPaths': json['GameSearchPaths'],
    };
}

export function FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderFxLauncherOptions {
    return FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderFxLauncherOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AdditionalLauncherArguments': value['AdditionalLauncherArguments'],
        'GameSearchPaths': value['GameSearchPaths'],
    };
}

